// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.pdt-page {
  padding: 0 48px 48px;
  max-width: 1400px;
}
@media (max-width: 991px) {
  .pdt-page {
    padding: 0 28px 36px;
  }
}
@media (max-width: 640px) {
  .pdt-page {
    padding: 0 16px 28px;
  }
}

.pdt-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  color: #ccc;
}
.pdt-breadcrumb__link {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.2s;
}
.pdt-breadcrumb__link:hover {
  color: rgb(0, 173, 208);
  text-decoration: none;
}
.pdt-breadcrumb__sep {
  color: #ccc;
  -webkit-user-select: none;
          user-select: none;
}
.pdt-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}
.pdt-breadcrumb__cart {
  margin-left: auto;
}
.pdt-breadcrumb__cart-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: #676a6c;
  font-size: 18px;
  transition: all 0.15s ease;
  text-decoration: none;
}
.pdt-breadcrumb__cart-link:hover {
  background: #f1f1f2;
  color: rgb(0, 173, 208);
}
.pdt-breadcrumb__cart-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: rgb(105, 190, 40);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.pdt-layout {
  display: flex;
  gap: 40px;
  padding: 24px 0 48px;
}
@media (max-width: 767px) {
  .pdt-layout {
    flex-direction: column;
    gap: 24px;
    padding: 16px 0 32px;
  }
}
.pdt-layout__image {
  flex: 0 0 40%;
  max-width: 40%;
}
@media (max-width: 767px) {
  .pdt-layout__image {
    flex: none;
    max-width: 100%;
  }
}
.pdt-layout__details {
  flex: 1;
  min-width: 0;
}

.pdt-image {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pdt-image img {
  width: 100%;
  height: auto;
  max-height: 500px;
  object-fit: contain;
  display: block;
}

.pdt-title {
  font-size: 28px;
  font-weight: 700;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #6d6e71;
  line-height: 1.25;
  margin: 0 0 12px;
}
@media (max-width: 480px) {
  .pdt-title {
    font-size: 24px;
  }
}

.pdt-price {
  display: block;
  font-size: 24px;
  font-weight: 700;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: rgb(105, 190, 40);
  margin-bottom: 20px;
}

.pdt-description {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #676a6c;
  line-height: 1.75;
  margin-bottom: 28px;
  max-width: 640px;
}
.pdt-description ::ng-deep p {
  margin: 0 0 16px;
}
.pdt-description ::ng-deep p:last-child {
  margin-bottom: 0;
}
.pdt-description ::ng-deep h1, .pdt-description ::ng-deep h2, .pdt-description ::ng-deep h3, .pdt-description ::ng-deep h4, .pdt-description ::ng-deep h5, .pdt-description ::ng-deep h6 {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #6d6e71;
  margin: 28px 0 10px;
  line-height: 1.3;
}
.pdt-description ::ng-deep h1:first-child, .pdt-description ::ng-deep h2:first-child, .pdt-description ::ng-deep h3:first-child, .pdt-description ::ng-deep h4:first-child, .pdt-description ::ng-deep h5:first-child, .pdt-description ::ng-deep h6:first-child {
  margin-top: 0;
}
.pdt-description ::ng-deep h2 {
  font-size: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e7eaec;
}
.pdt-description ::ng-deep h3 {
  font-size: 17px;
}
.pdt-description ::ng-deep h4 {
  font-size: 15px;
}
.pdt-description ::ng-deep blockquote {
  margin: 16px 0;
  padding: 12px 16px;
  border-left: 3px solid rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.03);
  font-style: italic;
  color: #808486;
}
.pdt-description ::ng-deep blockquote p {
  margin-bottom: 0;
}
.pdt-description ::ng-deep ul, .pdt-description ::ng-deep ol {
  padding-left: 24px;
  margin: 0 0 16px;
}
.pdt-description ::ng-deep ul {
  list-style: disc;
}
.pdt-description ::ng-deep ul ul {
  list-style: circle;
  margin-bottom: 0;
}
.pdt-description ::ng-deep ol {
  list-style: decimal;
}
.pdt-description ::ng-deep li {
  margin-bottom: 6px;
  line-height: 1.6;
  padding-left: 4px;
}
.pdt-description ::ng-deep li:last-child {
  margin-bottom: 0;
}
.pdt-description ::ng-deep table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 13px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e7eaec;
}
.pdt-description ::ng-deep table th, .pdt-description ::ng-deep table td {
  padding: 10px 14px;
  text-align: left;
  border-bottom: 1px solid #e7eaec;
}
.pdt-description ::ng-deep table th {
  background: #f1f1f2;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
}
.pdt-description ::ng-deep table tr:last-child td {
  border-bottom: none;
}
.pdt-description ::ng-deep table tr:hover td {
  background: rgba(0, 173, 208, 0.02);
}
.pdt-description ::ng-deep strong, .pdt-description ::ng-deep b {
  font-weight: 700;
  color: #535657;
}
.pdt-description ::ng-deep em, .pdt-description ::ng-deep i {
  font-style: italic;
}
.pdt-description ::ng-deep a {
  color: rgb(0, 173, 208);
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px solid rgba(0, 173, 208, 0.3);
  transition: all 0.15s ease;
}
.pdt-description ::ng-deep a:hover {
  color: #007a93;
  border-bottom-color: rgb(0, 173, 208);
}
.pdt-description ::ng-deep img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  margin: 12px 0;
}
.pdt-description ::ng-deep br {
  display: block;
  content: "";
  margin: 6px 0;
}
.pdt-description ::ng-deep hr {
  border: none;
  border-top: 1px solid #e7eaec;
  margin: 20px 0;
}

.pdt-variant label, .pdt-form-group label {
  display: block;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #676a6c;
  margin-bottom: 4px;
}

.pdt-variant select, .pdt-form-group select {
  width: 100%;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  padding: 8px 12px;
  height: 38px;
  background-color: #fff;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  appearance: auto;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.pdt-variant select:focus, .pdt-form-group select:focus {
  outline: none;
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.12);
}
.pdt-variant select:disabled, .pdt-form-group select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f5f5f5;
}

.pdt-assessment-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.pdt-variant {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
}
.pdt-variant select {
  max-width: 300px;
}

.pdt-custom-field {
  margin-bottom: 16px;
  max-width: 400px;
}
.pdt-custom-field label {
  display: block;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #676a6c;
  margin-bottom: 6px;
  line-height: 1.5;
}

.pdt-input {
  width: 100%;
  max-width: 400px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  padding: 10px 14px;
  height: 42px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #676a6c;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.pdt-input:focus {
  outline: none;
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}
.pdt-input::placeholder {
  color: #ccc;
}

.pdt-cart {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e7eaec;
}
.pdt-cart__row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pdt-qty {
  width: 72px;
  height: 42px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  padding: 4px 8px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 15px;
  text-align: center;
  color: #676a6c;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.pdt-qty::-webkit-inner-spin-button, .pdt-qty::-webkit-outer-spin-button {
  opacity: 1;
  height: 28px;
}
.pdt-qty:focus {
  outline: none;
  border-color: rgb(105, 190, 40);
  box-shadow: 0 0 0 3px rgba(105, 190, 40, 0.1);
}

.pdt-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 11px 28px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  line-height: 1;
  letter-spacing: 0.02em;
}
.pdt-btn--cart {
  background-color: rgb(105, 190, 40);
  color: #fff;
  box-shadow: 0 2px 6px rgba(105, 190, 40, 0.25);
}
.pdt-btn--cart:hover {
  background-color: #5ba523;
  box-shadow: 0 4px 12px rgba(105, 190, 40, 0.3);
  color: #fff;
  text-decoration: none;
}
.pdt-btn--disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
  box-shadow: none;
}
.pdt-btn--cart-sm {
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 12px;
  padding: 5px 12px;
  border-radius: 5px;
  border: 1.5px solid rgb(105, 190, 40);
}
.pdt-btn--cart-sm:hover {
  background-color: #569c21;
  border-color: #569c21;
  color: #fff;
  text-decoration: none;
}
.pdt-btn--outline-green-sm {
  background: transparent;
  color: rgb(105, 190, 40);
  font-size: 12px;
  padding: 5px 12px;
  border-radius: 5px;
  border: 1.5px solid rgb(105, 190, 40);
}
.pdt-btn--outline-green-sm:hover {
  background-color: rgb(105, 190, 40);
  color: #fff;
  text-decoration: none;
}
.pdt-btn--outline-cyan-sm {
  background: transparent;
  color: rgb(0, 173, 208);
  font-size: 12px;
  padding: 5px 12px;
  border-radius: 5px;
  border: 1.5px solid rgb(0, 173, 208);
}
.pdt-btn--outline-cyan-sm:hover {
  background-color: rgb(0, 173, 208);
  color: #fff;
  text-decoration: none;
}

.pdt-related {
  padding-bottom: 48px;
}
.pdt-related__title {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0 0 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e7eaec;
}
.pdt-related__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
}
@media (max-width: 640px) {
  .pdt-related__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}
@media (max-width: 400px) {
  .pdt-related__grid {
    grid-template-columns: 1fr;
  }
}

.pdt-related-card {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e7eaec;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}
.pdt-related-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-3px);
}
.pdt-related-card__image-link {
  display: block;
  text-decoration: none;
  overflow: hidden;
}
.pdt-related-card__image {
  width: 100%;
  aspect-ratio: 4/5;
  overflow: hidden;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}
.pdt-related-card__image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.35s ease;
}
.pdt-related-card__image:hover img {
  transform: scale(1.04);
}
.pdt-related-card__body {
  padding: 12px 14px 14px;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.pdt-related-card__name {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #6d6e71;
  text-decoration: none;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.35;
  margin-bottom: 6px;
  transition: color 0.2s;
}
.pdt-related-card__name:hover {
  color: rgb(105, 190, 40);
}
.pdt-related-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: auto;
  flex-wrap: wrap;
}
.pdt-related-card__price {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: rgb(105, 190, 40);
}
.pdt-related-card__actions {
  display: flex;
  gap: 6px;
}

::ng-deep .certification-link {
  color: #676a6c !important;
  text-decoration: underline;
}

::ng-deep .toolset-learner-kit {
  border-bottom: 0;
  border-left: 0;
  border-right: 0;
}
::ng-deep .toolset-learner-kit th {
  position: relative;
  border: 0 !important;
}
::ng-deep .toolset-learner-kit th code {
  background-color: #fff !important;
  border-radius: 0 !important;
  color: #676a6c !important;
  font-size: 1em !important;
}
::ng-deep .toolset-learner-kit th:not(:first-child) {
  text-align: center;
}
::ng-deep .toolset-learner-kit th em {
  font-style: normal;
  position: absolute;
  right: -6px;
}
::ng-deep .toolset-learner-kit tr td:not(:first-child) {
  text-align: center;
}
::ng-deep .toolset-learner-kit tr td:not(:first-child) code {
  background-color: #fff !important;
  border-radius: 0 !important;
  color: #676a6c !important;
  font-size: 1em !important;
}
::ng-deep .toolset-learner-kit tr:last-child td {
  background: #fff;
  border: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/store-product-details/store-product-details.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA5YA;EACE,oBAAA;EACA,iBAAA;AA+YF;AA7YE;EAJF;IAI8B,oBAAA;EAiZ5B;AACF;AAjZE;EALF;IAK8B,oBAAA;EAqZ5B;AACF;;AAlZA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,wEDhBW;ECiBX,eAAA;EACA,WDwBkB;AC6XpB;AAnZE;EACE,cDciB;ECbjB,qBAAA;EACA,sBAAA;AAqZJ;AAnZI;EACE,uBDLU;ECMV,qBAAA;AAqZN;AAjZE;EACE,WDUgB;ECThB,yBAAA;UAAA,iBAAA;AAmZJ;AAhZE;EACE,cDGiB;ECFjB,gBAAA;AAkZJ;AA/YE;EACE,iBAAA;AAiZJ;AA9YE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cDlBiB;ECmBjB,eAAA;EACA,0BAAA;EACA,qBAAA;AAgZJ;AA9YI;EACE,mBDhBgB;ECiBhB,uBDvCU;ACubhB;AA5YE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,6BDpDY;ECqDZ,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA8YJ;;AAzYA;EACE,aAAA;EACA,SAAA;EACA,oBAAA;AA4YF;AA1YE;EALF;IAMI,sBAAA;IACA,SAAA;IACA,oBAAA;EA6YF;AACF;AA3YE;EACE,aAAA;EACA,cAAA;AA6YJ;AA3YI;EAJF;IAKI,UAAA;IACA,eAAA;EA8YJ;AACF;AA3YE;EACE,OAAA;EACA,YAAA;AA6YJ;;AAxYA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA2YF;AAzYE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AA2YJ;;AAtYA;EACE,eAAA;EACA,gBAAA;EACA,wEDtIW;ECuIX,cD/FmB;ECgGnB,iBAAA;EACA,gBAAA;AAyYF;AAvYE;EARF;IASI,eAAA;EA0YF;AACF;;AAtYA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDrJW;ECsJX,wBD/Hc;ECgId,mBAAA;AAyYF;;AArYA;EACE,wED5JW;EC6JX,eAAA;EACA,cD3HmB;EC4HnB,iBAAA;EACA,mBAAA;EACA,gBAAA;AAwYF;AArYI;EACE,gBAAA;AAuYN;AAtYM;EAAe,gBAAA;AAyYrB;AAtYI;EACE,wED1KO;EC2KP,cDnIe;ECoIf,mBAAA;EACA,gBAAA;AAwYN;AAvYM;EAAgB,aAAA;AA0YtB;AAvYI;EACE,eAAA;EACA,mBAAA;EACA,gCAAA;AAyYN;AAtYI;EAAK,eAAA;AAyYT;AAxYI;EAAK,eAAA;AA2YT;AAzYI;EACE,cAAA;EACA,kBAAA;EACA,wCAAA;EACA,oCAAA;EACA,kBAAA;EACA,cAAA;AA2YN;AA1YM;EAAI,gBAAA;AA6YV;AA1YI;EACE,kBAAA;EACA,gBAAA;AA4YN;AAzYI;EACE,gBAAA;AA2YN;AA1YM;EAAK,kBAAA;EAAoB,gBAAA;AA8Y/B;AA3YI;EAAK,mBAAA;AA8YT;AA5YI;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;AA8YN;AA7YM;EAAe,gBAAA;AAgZrB;AA7YI;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AA+YN;AA7YM;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;AA+YR;AA5YM;EACE,mBD5Lc;EC6Ld,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDpMa;ACklBrB;AA3YM;EAAmB,mBAAA;AA8YzB;AA7YM;EAAc,mCAAA;AAgZpB;AA7YI;EACE,gBAAA;EACA,cAAA;AA+YN;AA5YI;EAAQ,kBAAA;AA+YZ;AA7YI;EACE,uBDtOU;ECuOV,qBAAA;EACA,gBAAA;EACA,+CAAA;EACA,0BAAA;AA+YN;AA7YM;EACE,cAAA;EACA,qCD9OQ;AC6nBhB;AA3YI;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AA6YN;AA1YI;EACE,cAAA;EACA,WAAA;EACA,aAAA;AA4YN;AAzYI;EACE,YAAA;EACA,6BAAA;EACA,cAAA;AA2YN;;AArYA;EACE,cAAA;EACA,wED/RW;ECgSX,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cDjQmB;ECkQnB,kBAAA;AAwYF;;AArYA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,cD5QmB;EC6QnB,wEDhTW;ECiTX,eAAA;EACA,gBAAA;EACA,8CAAA;AAwYF;AAtYE;EACE,aAAA;EACA,8BDlSY;ECmSZ,6CAAA;AAwYJ;AArYE;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;AAuYJ;;AAlYA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAqYF;;AA5XA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AA+XF;AA3XE;EAEE,gBAAA;AA4XJ;;AAvXA;EACE,mBAAA;EACA,gBAAA;AA0XF;AAxXE;EACE,cAAA;EACA,wEDrWS;ECsWT,eAAA;EACA,gBAAA;EACA,cDrUiB;ECsUjB,kBAAA;EACA,gBAAA;AA0XJ;;AAtXA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,wEDrXW;ECsXX,eAAA;EACA,cDpVmB;ECqVnB,gBAAA;EACA,8CAAA;AAyXF;AAvXE;EACE,aAAA;EACA,8BDxWY;ECyWZ,4CAAA;AAyXJ;AAtXE;EACE,WDxVgB;ACgtBpB;;AAnXA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AAsXF;AApXE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAsXJ;;AAlXA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wED1ZW;EC2ZX,eAAA;EACA,kBAAA;EACA,cD1XmB;EC2XnB,gBAAA;EACA,8CAAA;AAqXF;AAnXE;EAEE,UAAA;EACA,YAAA;AAoXJ;AAjXE;EACE,aAAA;EACA,+BDlZY;ECmZZ,6CAAA;AAmXJ;;AA9WA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wEDnbW;ECobX,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,sBAAA;AAiXF;AA/WE;EACE,mCDzaY;EC0aZ,WAAA;EACA,8CAAA;AAiXJ;AA/WI;EACE,yBAAA;EACA,8CAAA;EACA,WAAA;EACA,qBAAA;AAiXN;AA7WE;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AA+WJ;AA3WE;EACE,mCD9bY;EC+bZ,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qCAAA;AA6WJ;AA3WI;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;AA6WN;AAzWE;EACE,uBAAA;EACA,wBD/cY;ECgdZ,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qCAAA;AA2WJ;AAzWI;EACE,mCDtdU;ECudV,WAAA;EACA,qBAAA;AA2WN;AAvWE;EACE,uBAAA;EACA,uBDheY;ECieZ,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;AAyWJ;AAvWI;EACE,kCDveU;ECweV,WAAA;EACA,qBAAA;AAyWN;;AAnWA;EACE,oBAAA;AAsWF;AApWE;EACE,wEDxgBS;ECygBT,eAAA;EACA,gBAAA;EACA,cDneiB;ECoejB,gBAAA;EACA,oBAAA;EACA,gCAAA;AAsWJ;AAnWE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAqWJ;AAnWI;EALF;IAMI,qCAAA;IACA,SAAA;EAsWJ;AACF;AApWI;EAVF;IAWI,0BAAA;EAuWJ;AACF;;AAnWA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uDAAA;AAsWF;AApWE;EACE,0CAAA;EACA,2BAAA;AAsWJ;AAnWE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAqWJ;AAlWE;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAoWJ;AAlWI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;AAoWN;AAjWI;EACE,sBAAA;AAmWN;AA/VE;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;AAiWJ;AA9VE;EACE,wEDnlBS;EColBT,eAAA;EACA,gBAAA;EACA,cD9iBiB;EC+iBjB,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAgWJ;AA9VI;EACE,wBD3kBU;AC26BhB;AA5VE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AA8VJ;AA3VE;EACE,wEDhnBS;ECinBT,eAAA;EACA,gBAAA;EACA,wBD5lBY;ACy7BhB;AA1VE;EACE,aAAA;EACA,QAAA;AA4VJ;;AAvVA;EACE,yBAAA;EACA,0BAAA;AA0VF;;AAvVA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AA0VF;AAxVE;EACE,kBAAA;EACA,oBAAA;AA0VJ;AAxVI;EACE,iCAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;AA0VN;AAvVI;EACE,kBAAA;AAyVN;AAtVI;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AAwVN;AApVE;EACE,kBAAA;AAsVJ;AApVI;EACE,iCAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;AAsVN;AAlVE;EACE,gBAAA;EACA,oBAAA;AAoVJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n// ── Page Container ──────────────────────────────────────────────\n.pdt-page {\n  padding: 0 48px 48px;\n  max-width: 1400px;\n\n  @media (max-width: 991px) { padding: 0 28px 36px; }\n  @media (max-width: 640px) { padding: 0 16px 28px; }\n}\n\n// ── Breadcrumb ──────────────────────────────────────────────────\n.pdt-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 0;\n  font-family: $font-stack;\n  font-size: 13px;\n  color: $color-neutral-mid;\n\n  &__link {\n    color: $body-content-color;\n    text-decoration: none;\n    transition: color 0.2s;\n\n    &:hover {\n      color: $clarify-color;\n      text-decoration: none;\n    }\n  }\n\n  &__sep {\n    color: $color-neutral-mid;\n    user-select: none;\n  }\n\n  &__current {\n    color: $color-neutral-dark;\n    font-weight: 600;\n  }\n\n  &__cart {\n    margin-left: auto;\n  }\n\n  &__cart-link {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 8px;\n    color: $body-content-color;\n    font-size: 18px;\n    transition: all 0.15s ease;\n    text-decoration: none;\n\n    &:hover {\n      background: $color-neutral-light;\n      color: $clarify-color;\n    }\n  }\n\n  &__cart-badge {\n    position: absolute;\n    top: 2px;\n    right: 2px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 18px;\n    height: 18px;\n    padding: 0 5px;\n    border-radius: 9px;\n    background: $develop-color;\n    color: #fff;\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 1;\n  }\n}\n\n// ── Two-Column Layout ───────────────────────────────────────────\n.pdt-layout {\n  display: flex;\n  gap: 40px;\n  padding: 24px 0 48px;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    gap: 24px;\n    padding: 16px 0 32px;\n  }\n\n  &__image {\n    flex: 0 0 40%;\n    max-width: 40%;\n\n    @media (max-width: 767px) {\n      flex: none;\n      max-width: 100%;\n    }\n  }\n\n  &__details {\n    flex: 1;\n    min-width: 0;\n  }\n}\n\n// ── Product Image ───────────────────────────────────────────────\n.pdt-image {\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 10px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    height: auto;\n    max-height: 500px;\n    object-fit: contain;\n    display: block;\n  }\n}\n\n// ── Product Title ───────────────────────────────────────────────\n.pdt-title {\n  font-size: 28px;\n  font-weight: 700;\n  font-family: $font-stack;\n  color: $color-neutral-dark;\n  line-height: 1.25;\n  margin: 0 0 12px;\n\n  @media (max-width: 480px) {\n    font-size: 24px;\n  }\n}\n\n// ── Price ───────────────────────────────────────────────────────\n.pdt-price {\n  display: block;\n  font-size: 24px;\n  font-weight: 700;\n  font-family: $font-stack;\n  color: $develop-color;\n  margin-bottom: 20px;\n}\n\n// ── Description ─────────────────────────────────────────────────\n.pdt-description {\n  font-family: $font-stack;\n  font-size: 15px;\n  color: $body-content-color;\n  line-height: 1.75;\n  margin-bottom: 28px;\n  max-width: 640px;\n\n  ::ng-deep {\n    p {\n      margin: 0 0 16px;\n      &:last-child { margin-bottom: 0; }\n    }\n\n    h1, h2, h3, h4, h5, h6 {\n      font-family: $font-stack;\n      color: $color-neutral-dark;\n      margin: 28px 0 10px;\n      line-height: 1.3;\n      &:first-child { margin-top: 0; }\n    }\n\n    h2 {\n      font-size: 20px;\n      padding-bottom: 8px;\n      border-bottom: 1px solid $color-grey-1;\n    }\n\n    h3 { font-size: 17px; }\n    h4 { font-size: 15px; }\n\n    blockquote {\n      margin: 16px 0;\n      padding: 12px 16px;\n      border-left: 3px solid $develop-color;\n      background: rgba($develop-color, 0.03);\n      font-style: italic;\n      color: lighten($body-content-color, 10%);\n      p { margin-bottom: 0; }\n    }\n\n    ul, ol {\n      padding-left: 24px;\n      margin: 0 0 16px;\n    }\n\n    ul {\n      list-style: disc;\n      ul { list-style: circle; margin-bottom: 0; }\n    }\n\n    ol { list-style: decimal; }\n\n    li {\n      margin-bottom: 6px;\n      line-height: 1.6;\n      padding-left: 4px;\n      &:last-child { margin-bottom: 0; }\n    }\n\n    table {\n      width: 100%;\n      border-collapse: collapse;\n      margin: 20px 0;\n      font-size: 13px;\n      border-radius: 6px;\n      overflow: hidden;\n      border: 1px solid $color-grey-1;\n\n      th, td {\n        padding: 10px 14px;\n        text-align: left;\n        border-bottom: 1px solid $color-grey-1;\n      }\n\n      th {\n        background: $color-neutral-light;\n        font-weight: 700;\n        font-size: 11px;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n        color: $color-neutral-dark;\n      }\n\n      tr:last-child td { border-bottom: none; }\n      tr:hover td { background: rgba($clarify-color, 0.02); }\n    }\n\n    strong, b {\n      font-weight: 700;\n      color: darken($body-content-color, 8%);\n    }\n\n    em, i { font-style: italic; }\n\n    a {\n      color: $clarify-color;\n      text-decoration: none;\n      font-weight: 500;\n      border-bottom: 1px solid rgba($clarify-color, 0.3);\n      transition: all 0.15s ease;\n\n      &:hover {\n        color: darken($clarify-color, 12%);\n        border-bottom-color: $clarify-color;\n      }\n    }\n\n    img {\n      max-width: 100%;\n      height: auto;\n      border-radius: 6px;\n      margin: 12px 0;\n    }\n\n    br {\n      display: block;\n      content: '';\n      margin: 6px 0;\n    }\n\n    hr {\n      border: none;\n      border-top: 1px solid $color-grey-1;\n      margin: 20px 0;\n    }\n  }\n}\n\n// ── Shared Form Styles ──────────────────────────────────────────\n%pdt-label {\n  display: block;\n  font-family: $font-stack;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: $body-content-color;\n  margin-bottom: 4px;\n}\n\n%pdt-select {\n  width: 100%;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  padding: 8px 12px;\n  height: 38px;\n  background-color: #fff;\n  color: $body-content-color;\n  font-family: $font-stack;\n  font-size: 13px;\n  appearance: auto;\n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &:focus {\n    outline: none;\n    border-color: $clarify-color;\n    box-shadow: 0 0 0 3px rgba($clarify-color, 0.12);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    background-color: #f5f5f5;\n  }\n}\n\n// ── Assessment Form ─────────────────────────────────────────────\n.pdt-assessment-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.pdt-form-group {\n  label { @extend %pdt-label; }\n  select { @extend %pdt-select; }\n}\n\n// ── Variant Selector ────────────────────────────────────────────\n.pdt-variant {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 16px;\n\n  label { @extend %pdt-label; }\n\n  select {\n    @extend %pdt-select;\n    max-width: 300px;\n  }\n}\n\n// ── Custom Fields ───────────────────────────────────────────────\n.pdt-custom-field {\n  margin-bottom: 16px;\n  max-width: 400px;\n\n  label {\n    display: block;\n    font-family: $font-stack;\n    font-size: 13px;\n    font-weight: 700;\n    color: $body-content-color;\n    margin-bottom: 6px;\n    line-height: 1.5;\n  }\n}\n\n.pdt-input {\n  width: 100%;\n  max-width: 400px;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  padding: 10px 14px;\n  height: 42px;\n  font-family: $font-stack;\n  font-size: 14px;\n  color: $body-content-color;\n  background: #fff;\n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &:focus {\n    outline: none;\n    border-color: $clarify-color;\n    box-shadow: 0 0 0 3px rgba($clarify-color, 0.1);\n  }\n\n  &::placeholder {\n    color: $color-neutral-mid;\n  }\n}\n\n// ── Cart Section ────────────────────────────────────────────────\n.pdt-cart {\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid $color-grey-1;\n\n  &__row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n}\n\n.pdt-qty {\n  width: 72px;\n  height: 42px;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-family: $font-stack;\n  font-size: 15px;\n  text-align: center;\n  color: $body-content-color;\n  background: #fff;\n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &::-webkit-inner-spin-button,\n  &::-webkit-outer-spin-button {\n    opacity: 1;\n    height: 28px;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: $develop-color;\n    box-shadow: 0 0 0 3px rgba($develop-color, 0.1);\n  }\n}\n\n// ── Buttons ─────────────────────────────────────────────────────\n.pdt-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: $font-stack;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 11px 28px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  line-height: 1;\n  letter-spacing: 0.02em;\n\n  &--cart {\n    background-color: $develop-color;\n    color: #fff;\n    box-shadow: 0 2px 6px rgba($develop-color, 0.25);\n\n    &:hover {\n      background-color: darken($develop-color, 6%);\n      box-shadow: 0 4px 12px rgba($develop-color, 0.3);\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n\n  &--disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n    pointer-events: none;\n    box-shadow: none;\n  }\n\n  // Related product buttons (smaller)\n  &--cart-sm {\n    background-color: $develop-color;\n    color: #fff;\n    font-size: 12px;\n    padding: 5px 12px;\n    border-radius: 5px;\n    border: 1.5px solid $develop-color;\n\n    &:hover {\n      background-color: darken(rgba(105, 190, 40, 1), 8%);\n      border-color: darken(rgba(105, 190, 40, 1), 8%);\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n\n  &--outline-green-sm {\n    background: transparent;\n    color: $develop-color;\n    font-size: 12px;\n    padding: 5px 12px;\n    border-radius: 5px;\n    border: 1.5px solid $develop-color;\n\n    &:hover {\n      background-color: $develop-color;\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n\n  &--outline-cyan-sm {\n    background: transparent;\n    color: $clarify-color;\n    font-size: 12px;\n    padding: 5px 12px;\n    border-radius: 5px;\n    border: 1.5px solid $clarify-color;\n\n    &:hover {\n      background-color: $clarify-color;\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n}\n\n// ── Related Products ────────────────────────────────────────────\n.pdt-related {\n  padding-bottom: 48px;\n\n  &__title {\n    font-family: $font-stack;\n    font-size: 24px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0 0 20px;\n    padding-bottom: 12px;\n    border-bottom: 2px solid $color-grey-1;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 20px;\n\n    @media (max-width: 640px) {\n      grid-template-columns: repeat(2, 1fr);\n      gap: 12px;\n    }\n\n    @media (max-width: 400px) {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n.pdt-related-card {\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid $color-grey-1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: box-shadow 0.25s ease, transform 0.25s ease;\n\n  &:hover {\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n    transform: translateY(-3px);\n  }\n\n  &__image-link {\n    display: block;\n    text-decoration: none;\n    overflow: hidden;\n  }\n\n  &__image {\n    width: 100%;\n    aspect-ratio: 4 / 5;\n    overflow: hidden;\n    background: #f8f9fa;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px;\n\n    img {\n      max-width: 100%;\n      max-height: 100%;\n      object-fit: contain;\n      transition: transform 0.35s ease;\n    }\n\n    &:hover img {\n      transform: scale(1.04);\n    }\n  }\n\n  &__body {\n    padding: 12px 14px 14px;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n  }\n\n  &__name {\n    font-family: $font-stack;\n    font-size: 13px;\n    font-weight: 600;\n    color: $color-neutral-dark;\n    text-decoration: none;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: 1.35;\n    margin-bottom: 6px;\n    transition: color 0.2s;\n\n    &:hover {\n      color: $develop-color;\n    }\n  }\n\n  &__footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    margin-top: auto;\n    flex-wrap: wrap;\n  }\n\n  &__price {\n    font-family: $font-stack;\n    font-size: 14px;\n    font-weight: 700;\n    color: $develop-color;\n  }\n\n  &__actions {\n    display: flex;\n    gap: 6px;\n  }\n}\n\n// ── Legacy deep selectors for innerHTML content ─────────────────\n::ng-deep .certification-link {\n  color: $body-content-color !important;\n  text-decoration: underline;\n}\n\n::ng-deep .toolset-learner-kit {\n  border-bottom: 0;\n  border-left: 0;\n  border-right: 0;\n\n  th {\n    position: relative;\n    border: 0 !important;\n\n    code {\n      background-color: #fff !important;\n      border-radius: 0 !important;\n      color: $body-content-color !important;\n      font-size: 1em !important;\n    }\n\n    &:not(:first-child) {\n      text-align: center;\n    }\n\n    em {\n      font-style: normal;\n      position: absolute;\n      right: -6px;\n    }\n  }\n\n  tr td:not(:first-child) {\n    text-align: center;\n\n    code {\n      background-color: #fff !important;\n      border-radius: 0 !important;\n      color: $body-content-color !important;\n      font-size: 1em !important;\n    }\n  }\n\n  tr:last-child td {\n    background: #fff;\n    border: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
